import styled from 'styled-components'
import { theme, colors } from '../../../../../../theme/Global'

export const TopicNavListItem = styled.li`
  display: 'block';
`
export const TopicNav = styled.div`
  align-items: center;
  box-sizing: unset;
  cursor: pointer;
  display: flex;
  margin-left: 4px;
  padding: 0 0 0 15px;

  &:focus {
    outline: unset;
  }

  &:focus:before {
      padding-left: 10px;
      height: inherit;
      left: 0px;

      position: absolute;
      content: " ";
      width: 1rem;
      z-index: 1000;
    }
  }

  &.selected {
    border-left: 4px solid ${colors.govDocsBlue};
    color: ${theme.colors.darkBlueText};
    font-weight: 600;
    margin-left: 0px;
  }
}`
